import chroma from 'chroma-js';
import theme from './theme';

/**
 * Devuelve blanco o negro para el mejor contraste dependiendo de la luminosidad del color dado.
 * Sigue la especificación del W3C para legibilidad
 * @see https://www.w3.org/TR/WCAG20-TECHS/G18.html
 * @see https://gka.github.io/chroma.js/#color-luminance
 * @see https://github.com/styled-components/polished/blob/main/src/color/readableColor.js
 * @param   {Object} arg
 * @param   {string} arg.color
 * @param   {string} [arg.black='#000'] - Color para el negro
 * @param   {string} [arg.white='#fff'] - Color para el blanco
 * @returns {string}
 */
const getReadableColor = ({ color, black = '#000', white = '#fff' }) => {
  const luminanceThreshold = 0.179;

  const luminance = chroma(color).luminance();
  const isLightColor = luminance > luminanceThreshold;

  return isLightColor ? black : white;
};

/**
 * Devuelve un gradiente en base al color indicado
 * @param {Object} arg
 * @param {string} arg.color
 * @param {Object} [arg.theme]
 * @returns {Object}
 */
const getSafeGradient = ({ color, theme: customTheme = theme }) => {
  const matchGradient = customTheme?.gradients[color];
  const gradient = matchGradient ?? { from: color, to: color };
  return gradient;
};

export { getReadableColor, getSafeGradient };
